const draggable = "_35sdeszqw3";

export { draggable };
import "./atom.draggable.style.linaria.module.css";
//# sourceMappingURL=atom.draggable.style.js.map
